// Registers the hand-written service worker in public/sw.js.
//
// Production only: in development a service worker caches stale bundles and
// makes hot reload behave unpredictably.

export const register = () => {
  if (process.env.NODE_ENV !== 'production') return;
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((error) => {
      // Registration failing is not fatal — the app works without it, it just
      // isn't installable and won't open offline.
      console.warn('Service worker registration failed:', error);
    });
  });
};

export const unregister = () => {
  if (!('serviceWorker' in navigator)) return;
  navigator.serviceWorker.ready
    .then((registration) => registration.unregister())
    .catch(() => {});
};
